import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Tofurkey Journey",
  date: new Date(2023, 10, 19),
  img: "/img/gangsters.jpeg",
  tracks: [
    {
      title: "Anticipation Elation",
      src: "/songs/2023-11-19/anticipation_elation.mp3",
    },
    { title: "What Is Done", src: "/songs/2023-11-19/what_is_done.mp3" },
    {
      title: "Cornhole Practice",
      src: "/songs/2023-11-19/cornhole_practice.mp3",
    },
    { title: "B-Side Aside", src: "/songs/2023-11-19/b_side_aside.mp3" },
    { title: "Holiday Prep", src: "/songs/2023-11-19/holiday_prep.mp3" },
    {
      title: "Turkey Lurkey",
      src: "/songs/2023-11-19/turkey_lurkey.mp3",
    },
    {
      title: "Whispering Words",
      src: "/songs/2023-11-19/whispering_words.mp3",
    },
    {
      title: "Behind The Scenes",
      src: "/songs/2023-11-19/behind_the_scenes.mp3",
    },
    { title: "Inside Doubt", src: "/songs/2023-11-19/inside_doubt.mp3" },
    { title: "Give It Up", src: "/songs/2023-11-19/give_it_up.mp3" },
    {
      title: "Self-Repairing Symbiotes",
      src: "/songs/2023-11-19/self_repairing_symbiotes.mp3",
    },
    { title: "Go Ahead", src: "/songs/2023-11-19/go_ahead.mp3" },
    {
      title: "Bring It On Home",
      src: "/songs/2023-11-19/bring_it_on_home.mp3",
    },
    { title: "Night Shift", src: "/songs/2023-11-19/night_shift.mp3" },
    { title: "Got Nothing", src: "/songs/2023-11-19/got_nothing.mp3" },
    {
      title: "Hanging In The Balance",
      src: "/songs/2023-11-19/hanging_in_the_balance.mp3",
    },
    {
      title: "Hunker Down Cindy",
      src: "/songs/2023-11-19/hunker_down_cindy.mp3",
    },
    {
      title: "Hold The Line",
      src: "/songs/2023-11-19/hold_the_line.mp3",
    },
    {
      title: "Motorcycle Channel",
      src: "/songs/2023-11-19/motorcycle_channel.mp3",
    },
    { title: "Unwind Down", src: "/songs/2023-11-19/unwind_down.mp3" },
    {
      title: "Get To Know You",
      src: "/songs/2023-11-19/get_to_know_you.mp3",
    },
  ],
};
export default album;
